import React from 'react';
import { ConfigProvider } from 'antd';
import { Tooltip } from '@ui-library/tooltip';
import { nextButtonTheme } from '@ui-library/next/tokens';
import {
  DefaultButton,
  LinkButton,
  NextButton,
  PrimaryButton,
  SecondaryButton,
  ButtonProps,
} from './styles';

export type { ButtonProps } from './styles';

export const Button: React.FC<ButtonProps> = (props) => {
  const {
    icon,
    type = 'primary',
    variant = 'default',
    level = 'primary',
    intent = 'default',
    tooltip: { title = '', placement = 'top', trigger = 'hover', show = true } = {},
    size: sizeProp,
    noPadding = false,
    ...others
  } = props;

  const size = sizeProp ?? (variant === 'next' ? 'middle' : 'large');

  const comp = (() => {
    const danger = variant === 'danger';

    if (variant === 'next') {
      const antTypeMap = { primary: 'primary', secondary: 'default', tertiary: 'text' } as const;
      const antType = antTypeMap[level];
      return (
        <ConfigProvider theme={nextButtonTheme}>
          <NextButton
            {...others}
            type={antType}
            $level={level}
            $intent={intent}
            size={size === 'xlarge' ? 'large' : size}
            icon={icon}
          >
            {props.name ?? others.children}
          </NextButton>
        </ConfigProvider>
      );
    }

    if (type === 'secondary') {
      return (
        <SecondaryButton {...others} variant={variant} size={size} icon={icon}>
          {props.name ?? others.children}
        </SecondaryButton>
      );
    }

    if (type === 'text' || type === 'link') {
      return (
        <LinkButton
          {...others}
          noPadding={noPadding}
          type={type}
          danger={danger}
          size={size}
          icon={icon}
        >
          {props.name ?? others.children}
        </LinkButton>
      );
    }

    if (type === 'primary') {
      return (
        <PrimaryButton
          {...others}
          type="primary"
          variant={variant}
          danger={danger}
          size={size}
          icon={icon}
        >
          {props.name ?? others.children}
        </PrimaryButton>
      );
    }

    return (
      <DefaultButton {...others} type="default" variant={variant} size={size} icon={icon}>
        {props.name ?? others.children}
      </DefaultButton>
    );
  })();

  if (title && show) {
    return (
      <Tooltip title={title} placement={placement} trigger={trigger}>
        {comp}
      </Tooltip>
    );
  }

  return comp;
};
